import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';

export const getAvailableCompanies = async (): Promise<AxiosResponse> => {
	return await companiesApi.get('/brokers/companies');
};

export const changeCompany = async (
	companyId: string,
): Promise<AxiosResponse> => {
	return await companiesApi.patch('/brokers/companies/change-company-session', {
		companyId,
	});
};
